import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cmp-card-header',
  template: `<h6 class="header-title mb-0 mr-3 float-left" *ngIf="title">{{title}}</h6>
<div class="buttons-left_ header-buttons-left mb-0 float-left">
  <ng-content select="[left]"></ng-content>
</div>
<div class="buttons-rigth_ buttons-group float-right">
  <ng-content select="[right]"></ng-content>
</div>
`,
  styles: [`.buttons-left_:empty,.buttons-rigth_:empty,.header-title:empty{display:none}`]
})
export class CardHeaderComponent implements OnInit {

  @HostBinding('class') classes = 'card-header clearfix bg-white';
  @Input() title: any;

  constructor() {}

  ngOnInit() {

  }

}
